import { endOfYear, getYear, startOfYear } from 'date-fns'

import {
  DAY,
  MAX_YEAR_OFFSET_FROM_NOW,
  MIN_YEAR,
  YEAR_FIRST_MONTH,
} from '../../../constants/date'
import { DateLimits } from '../../../context'
import { useDate, useTimeZone } from '../../../hooks'
import { createDate } from '../../../utils/date'

function DateLimitsProvider({ children }) {
  const tz = useTimeZone()
  const year = getYear(useDate(DAY))

  const value = {
    maxDate: endOfYear(
      createDate(tz, year + MAX_YEAR_OFFSET_FROM_NOW, YEAR_FIRST_MONTH)
    ),
    minDate: startOfYear(createDate(tz, MIN_YEAR, YEAR_FIRST_MONTH)),
  }

  return <DateLimits value={value}>{children}</DateLimits>
}

export default DateLimitsProvider
